import { CmsQuoteProps } from '~/types/Cms';

const CmsQuote = ({ data }: CmsQuoteProps) => {
  const alignment = data.align || 'inherit';
  return (
    <figure className="cms-quote" style={{ textAlign: alignment }}>
      <blockquote className="blockquote" dangerouslySetInnerHTML={{ __html: data.content }} />
      {data.author && <figcaption className="blockquote-footer">{data.author}</figcaption>}
    </figure>
  );
};

export default CmsQuote;
